<script setup lang="ts">
defineProps<{ text: string; label: string }>()
</script>

<template>
  <pre
    class="h-full overflow-auto bg-slate-50 p-4 font-mono text-xs leading-relaxed whitespace-pre-wrap text-slate-800 dark:bg-slate-900 dark:text-slate-200"
    :aria-label="label"
    tabindex="0"
  ><code>{{ text }}</code></pre>
</template>
